import React, { useContext, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { ZoomMtg } from "@zoom/meetingsdk";
// services
// import { endMeeting } from "../../services/zoom/zoom_meeting";
// lib
import { decryptObject } from "../../lib/cryptoJs";
import { endMeeting } from "../../services/auth";

import SocketContext from "../../config/SocketContext";

import io from "socket.io-client";
import key from "../../config/index";
// let connect = false;
const SDK_KEY = process.env.REACT_APP_ZOOM_CLIENT_ID;
const FRONT_URL = window.location.origin;
const leaveUrl = `${FRONT_URL}/dashboard`;

const ZoomMeeting = () => {
  // hooks
  const { token } = useParams();

  let {
    meetingType,
    meetingId: meetingNumber,
    meetingPassword: password,
    signature,
    duration,
    email,
    userName,
    userId,
  } = decryptObject(token, true);

  const socket = io(key?.API_URL);

  const socketContext = useContext(SocketContext);

  // ref
  const mediaRecorderRef = useRef(null);
  const recordedChunksRef = useRef([]);

  // const checkMeetingExpiration = () => {
  //     const currentTime = Math.floor(Date.now() / 1000);
  //     const timeRemaining = (expireTimeStamp - currentTime) * 1000;
  //     setTimeout(() => {
  //         stopRecording();
  //     }, timeRemaining);
  // };

  const startRecording = async () => {
    try {
      // alert('Start Rec')
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;
      recordedChunksRef.current = [];

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          recordedChunksRef.current.push(event.data);
        }
      };

      mediaRecorder.onstop = async () => {
        const blob = new Blob(recordedChunksRef.current, {
          type: "audio/webm",
        });
        const audioFile = new File([blob], "recording.webm", {
          type: "audio/webm",
        });

        const formData = new FormData();
        formData.append("zoomAudio", audioFile);
        formData.append("meetingId", meetingNumber);

        try {
          await endMeeting(formData);
        } catch (error) {
          console.error("Error sending audio file:", error);
        }
      };

      mediaRecorder.start();
    } catch (error) {
      console.error("Error starting audio recording:", error);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
    }
  };

  const emitJoinMeeting = () => {
    try {
      let data = {
        meetingId: meetingNumber,
        userId,
        meetingType,
        userType: "HR",
      };
      socket.emit("MEETING_JOIN", data);
    } catch (error) {
      console.log(error, "errorrr");
    }
  };

  const joinMeeting = () => {
    ZoomMtg.preLoadWasm();
    ZoomMtg.prepareWebSDK();

    document.getElementById("zmmtg-root").style.display = "block";

    // WHEN USER CLICK ON END MEETING FOR ALL (OR) LEAVE MEETING BUTTON
    ZoomMtg.inMeetingServiceListener("onUserLeave", function (data) {
      if ([1, 2].includes(data?.reasonCode)) {
        // reasonCode 1 - ALL ENDED, 2 - Only Me Ended
        stopRecording();
      }
    });

    ZoomMtg.init({
      leaveUrl: leaveUrl,
      patchJsMedia: true,
      leaveOnPageUnload: true,
      disableInvite: true,
      success: async (success) => {
        console.log(success);
        // await checkMeetingExpiration();
        ZoomMtg.join({
          signature: signature,
          sdkKey: SDK_KEY,
          meetingNumber: meetingNumber,
          passWord: password,
          userName: userName,
          userEmail: email,
          tk: "",
          zak: "",
          success: async (success) => {
            startRecording();
            emitJoinMeeting();
          },
          error: (error) => {
            console.log(error, "sssss");
          },
        });
      },
      error: (error) => {
        console.log(error, "sssssssssss");
      },
    });
  };

  useEffect(() => {
    if (
      userName != "" &&
      email != "" &&
      meetingNumber != "" &&
      password != "" &&
      signature != ""
    ) {
      joinMeeting();
    }

    console.error(meetingNumber, signature, password, userName, email, "kalai");
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      emitJoinMeeting();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      id="meetingSDKElement"
      style={{ width: "100%", height: "100vh" }}
    ></div>
  );
};

export default ZoomMeeting;
